<picture>
  @for (thumbnailFileName of expert()?.ThumbnailFileNames; track thumbnailFileName)
  {
  <source [srcset]="thumbnailFileName" [type]="getMimeType(thumbnailFileName)" />
  }
  <img itemprop="image" [alt]="expert()?.Nickname" loading="lazy" [width]="expert()?.ThumbnailWidth" [height]="expert()?.ThumbnailHeight">
</picture>
